import { Box, Card, LinearProgress, Stack, Typography } from '@mui/joy';

const StubAICreditsCard = () => (
  <Card sx={{ py: '12px', px: 2 }}>
    <Stack gap={'5px'} alignItems='center'>
      <Box>
        <Typography
          sx={{ color: 'text.primary', fontSize: '14px', fontWeight: 700, lineHeight: '142%' }}
        >
          Screening credits{' '}
          <Typography
            fontWeight='md'
            fontSize='xs'
            component='span'
            sx={{ color: (theme) => theme.palette.text.tertiary }}
          >
            Your org. has used 0/25 screenings
          </Typography>
        </Typography>
      </Box>
      <LinearProgress
        determinate
        value={0}
        thickness={8}
        sx={{
          width: 1,
          bgcolor: (theme) => theme.palette['border']['border'],
        }}
      />
    </Stack>
  </Card>
);

export { StubAICreditsCard };
